import type React from 'react';
import clsx from 'clsx';

import type { UIComponentBase } from '../../../@types/types';
import { tenantConfig } from '../../../config/tenants';

// Dev/ephemeral builds stamp VITE_VERSION with a full UUID (do/build_frontend.sh). max-w-[11ch]
// covers "XXX.XXX.XXX" semver in full, so higher environments never get truncated; the UUID
// overflows and is clipped by `truncate`, with the full value available via the title attribute.
const VersionLabel = ({ version }: { version: string }) => (
  <p
    className="text-info-400 flex max-w-full text-xs font-semibold tracking-widest uppercase"
    title={`Version ${version}`}
  >
    Version&nbsp;<span className="max-w-[11ch] truncate">{version}</span>
  </p>
);

const AuthLayout: React.FC<UIComponentBase> = ({ children }) => (
  <div className="bg-info-100 flex h-screen w-full flex-col items-center justify-center bg-cover bg-center font-['Inter']!">
    <div className={clsx('flex w-full max-w-[480px] flex-col overflow-y-auto rounded-sm bg-white pt-8 shadow-xl')}>
      <div className="flex flex-col items-center gap-5">
        <img src={tenantConfig.logo} className="self-center" alt="Logo" />
        <h1 className="text-xl font-semibold">Contract Builder</h1>
        {import.meta.env.VITE_VERSION && <VersionLabel version={import.meta.env.VITE_VERSION} />}
      </div>
      <div className="mt-12 flex-auto px-10 pb-10">{children}</div>
    </div>
  </div>
);

export default AuthLayout;
